import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../AnimationContents';
import { GameModel } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { SoundModel } from '../../Models/SoundModel';

export interface ILeaderboardScreenDurationItemControllerOptions {
    onClick: () => void;
}

export class LeaderboardScreenDurationItemController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: ILeaderboardScreenDurationItemControllerOptions,
    ) {
        super('LeaderboardScreenDurationItemController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            onPointerDown: () => {
                if (this._options.onClick) {
                    this._options.onClick();
                }
            }
        };
    }

    protected onInitialize(): void {
    }

    protected onResize(width: number, height: number, scale: number): void {
    }

    public setActive(value: boolean): void {
        this.gotoAndStop(value ? 'active' : 'inactive');
    }
}
